import PlMessageContainer from './pl-message-container'

class MessageService {
    _el;
    $lv;
    containers = {}

    default = {
        id: null,
        horizontal: 'center',
        vertical: 'start',
        type: 'white',
        time: 3000,
        done: null,
        click: null,
    }

    get el() {
        if (!this._el) {
            this._el = document.createElement('div')
            this.$lv.$dom.addClass(this._el, 'pl-message-containers')
            document.body.appendChild(this._el)
        }
        return this._el
    }

    constructor($lv) {
        this.$lv = $lv
    }

    newInstance(horizontal, vertical) {
        const instance = this.$lv.newInstance(PlMessageContainer)
        instance.p_horizontal = horizontal
        instance.p_vertical = vertical
        this.el.appendChild(instance.$el)
        return instance
    }

    /**
     * 显示提示消息
     * @author  韦胜健
     * @date    2018/12/24 09:58
     * option参数详解
     * @param id                    显示的消息自动生成的id
     * @param horizontal            显示消息的横向位置
     * @param vertical              显示消息的纵向位置
     * @param type                  显示消息的类型
     * @param time                  显示消息自定关闭的时间
     * @param done                  显示的消息自动关闭触发的动作
     * @param click                 显示的消息点击触发动作
     * @param message               显示消息的文本内容
     */
    show(message, option) {
        if (this.$lv.$utils.typeOf(message) === 'object') {
            option = Object.assign({}, this.default, message)
        } else {
            option = Object.assign({}, this.default, option, {message})
        }
        option.id = option.id || this.$lv.$utils.uuid()
        const position = `${option.horizontal}-${option.vertical}`
        const container = this.containers[position] || this.newInstance(option.horizontal, option.vertical)
        if (!this.containers[position]) this.containers[position] = container
        this.$lv.Vue.prototype.$nextTick(() => container.add(option))
        return option
    }

    close(messageOption) {
        this.containers[`${messageOption.horizontal}-${messageOption.vertical}`].remove(messageOption)
    }
}

export {
    MessageService
}
